const createDots = (
  doc,
  numX,
  numY,
  startX,
  startY,
  anim = mina.easeinout,
  dots = [],
) => {
  if (doc) {
    for (let x = 0; x < numX; x++) {
      dots.push([]);
      for (let y = 0; y < numY; y++) {
        dots[x].push(
          doc
            .circle(startX + x * 80, startY + y * 80, 2)
            .attr({
              fill: '#fff',
              fillOpacity: '0',
            })
            .animate(
              {
                fillOpacity: '0.2',
              },
              500,
              anim,
            ),
        );
      }
    }
  }
};

export default createDots;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/create-dots.js